import { useSelector } from "react-redux";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  BiTrendingUp,
  BiData,
  BiListUl,
  BiStore,
  BiCart,
  BiUserPlus,
  BiPhoneCall
} from "react-icons/bi";
import calender from "./../assets/svg/os-icon-calendar.svg";
import QuickActions from "../Components/DashboardAnalytics/QuickActions";

const hubCards = [
  {
    title: "Sales Dashboard",
    path: "/dashboard/sales",
    icon: <BiTrendingUp size={32} />,
    color: "#0d6efd",
    description: "Sales trends, revenue, and top performing shops."
  },
  {
    title: "Data Dashboard",
    path: "/dashboard/data",
    icon: <BiData size={32} />,
    color: "#6f42c1",
    description: "Models, variants, and data growth metrics."
  },
  {
    title: "Listings Dashboard",
    path: "/dashboard/listings",
    icon: <BiListUl size={32} />,
    color: "#20c997",
    description: "Recent listings, categories, and shop-wise listing counts."
  },
  {
    title: "Stores Dashboard",
    path: "/dashboard/stores",
    icon: <BiStore size={32} />,
    color: "#fd7e14",
    description: "Shop registrations, status, and fulfillment over time."
  },
  {
    title: "Marketplace Dashboard",
    path: "/dashboard/marketplace",
    icon: <BiCart size={32} />,
    color: "#dc3545",
    description: "Marketplace orders, products, and fulfillment stats."
  },
  {
    title: "Seller Onboarding",
    path: "/dashboard/seller-onboarding",
    icon: <BiUserPlus size={32} />,
    color: "#6610f2",
    description: "Registration requests, conversion funnel, and team performance."
  },
  {
    title: "Order Operations",
    path: "/dashboard/order-operations",
    icon: <BiPhoneCall size={32} />,
    color: "#198754",
    description: "Order verification, tracking, payments, and refunds."
  }
];

const DashboardHub = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const userType = user?.user_type;
  const currentDate = new Date().toDateString();

  const today = new Date();
  const currentTime = today.getHours();
  let showtime;
  if (currentTime < 12) {
    showtime = "Good Morning";
  } else if (currentTime < 18) {
    showtime = "Good Afternoon";
  } else {
    showtime = "Good Evening";
  }

  return (
    <Container fluid className="px-xl-5">
      <Row>
        <Col lg="6">
          <h4>
            Hello <span className="text-capitalize">{user && user.user_full_name}</span> 👋🏼,
          </h4>
        </Col>
        <Col lg="6" className="text-start text-md-end py-2">
          <img src={calender} alt="calender" /> <span className="ms-1">{currentDate}</span>
        </Col>
      </Row>
      <p>{showtime}!</p>

      <QuickActions />

      {!(userType === "super-admin" || Number(user?.permissionObject?.AnalyticsDashboards) === 1) ? (
        <Row className="py-5">
          <Col className="text-center">
            <h5 className="text-muted">Welcome to the admin dashboard.</h5>
            <p className="text-muted">Your dashboard view is currently limited to this greeting.</p>
          </Col>
        </Row>
      ) : (
        <>
          <Row className="py-2">
            <Col>
              <h6 className="fw-bold text-muted">Choose a dashboard</h6>
            </Col>
          </Row>
          <Row className="g-4">
            {hubCards.map((card) => (
              <Col key={card.title} md="6" lg="4" xl="3" xxl="2">
                <Card
                  className="h-100 border-0 shadow-sm p-3 cursor-pointer hover-shadow"
                  onClick={() => navigate(card.path)}
                  style={{ cursor: "pointer", transition: "transform 0.15s" }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-3px)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{ width: 56, height: 56, backgroundColor: `${card.color}15`, color: card.color }}
                  >
                    {card.icon}
                  </div>
                  <h6 className="fw-bold mb-2">{card.title}</h6>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    {card.description}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </Container>
  );
};

export default DashboardHub;
